/** Dictionary of options for the name suffix autocomplete dropdown. Key is an internal value, and the associated value is the UI label */
export const suffixOptions = [
    { label: 'Jr.', id: 'Jr.' },
    { label: 'Sr.', id: 'Sr.' },
    { label: 'II', id: 'II' },
    { label: 'III', id: 'III' },
    { label: 'IV', id: 'IV' },
    { label: 'V', id: 'V' }
];
